<template>
  <div class="page-container">
    <div class="update-container">
      <div :class="{ 'upload-data': uploadData }" class="content-wrapper">
        <circle-loader v-if="uploadData" size="xlarge" :indeterminate="true" />

        <div v-if="editObject !== null" class="row">
          <div class="col-6">
            <div class="row">
              <div class="col-12">
                <form-data
                  label="ФИО"
                  placeholder="ФИО"
                  fieldname="editObject.full_name"
                  :input-model="editObject.full_name"
                  :error="validationErrors.full_name"
                  :error-info="errorsInfos.full_name ? errorsInfos.full_name : ''"
                  :server-error="serverErrors.full_name"
                  @update="updateData"
                />
              </div>
              <div class="col-12">
                <form-multi-select
                  :input-model="positions"
                  :choosed="editObject.positions"
                  label="Должность"
                  fieldname="editObject.positions"
                  @update="updateData"
                />
              </div>
              <div class="col-6">
                <form-data
                  label="Табельный номер"
                  placeholder="Табельный номер"
                  fieldname="editObject.employee_number"
                  :input-model="editObject.employee_number"
                  :error="validationErrors.employee_number"
                  :error-info="errorsInfos.employee_number ? errorsInfos.employee_number : ''"
                  :server-error="serverErrors.employee_number"
                  @update="updateData"
                />
              </div>
              <div class="col-6">
                <Input
                  label="Телефон"
                  placeholder="Телефон"
                  fieldname="editObject.phone"
                  :input-model="editObject.phone"
                  :error="validationErrors.phone"
                  :error-info="errorsInfos.phone ? errorsInfos.phone : ''"
                  :server-error="serverErrors.phone"
                  :mask="inputMasks.phone"
                  @update="updateData"
                />
              </div>
              <template v-if="editObject.positions !== null && isDriver()">
                <div class="col-6">
                  <Input
                    label="Серия водительского удостоверения"
                    placeholder="Серия водительского удостоверения"
                    fieldname="editObject.driving_licence_series"
                    :input-model="editObject.driving_licence_series"
                    :error="validationErrors.driving_licence_series"
                    :error-info="errorsInfos.driving_licence_series ? errorsInfos.driving_licence_series : ''"
                    :server-error="serverErrors.driving_licence_series"
                    :mask="inputMasks.driving_licence_series"
                    @update="updateData"
                  />
                </div>
                <div class="col-6">
                  <Input
                    label="№ водительского удостоверения"
                    placeholder="№ водительского удостоверения"
                    fieldname="editObject.driving_licence_number"
                    :input-model="editObject.driving_licence_number"
                    :error="validationErrors.driving_licence_number"
                    :error-info="errorsInfos.driving_licence_number ? errorsInfos.driving_licence_number : ''"
                    :server-error="serverErrors.driving_licence_number"
                    :mask="inputMasks.driving_licence_number"
                    @update="updateData"
                  />
                </div>
                <div class="col-6">
                  <form-multi-select
                    :input-model="categories"
                    :choosed="editObject.driving_licence_categories"
                    label="Категория водительского удостоверения"
                    fieldname="editObject.driving_licence_categories"
                    @update="updateData"
                  />
                </div>
              </template>
              <div class="col-6">
                <form-data
                  label="Email"
                  placeholder="Email"
                  fieldname="editObject.email"
                  :input-model="editObject.email"
                  :error="validationErrors.email"
                  :error-info="errorsInfos.email ? errorsInfos.email : ''"
                  :server-error="serverErrors.email"
                  @update="updateData"
                />
              </div>
            </div>
          </div>
          <div class="col-6">
            <container-image-infinitely
              :value="editObject.attachments"
              fieldname="attachments"
              @update="updateData"
              @set-upload-data="setUploadData"
              @add-file="newAddImage"
              @delete-file="newDeleteImage"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";

import FormData from "../../../../components/forms/FormData";
import Input from "../../../../components/forms/Input";
import FormMultiSelect from "../../../../components/forms/FormMultiSelect";
import ContainerImageInfinitely from "../../../../components/ContainerImageInfinitely";
import CircleLoader from "../../../../components/CircleLoader";

export default {
  name: "UpdateStaff",
  components: {
    FormData,
    Input,
    FormMultiSelect,
    ContainerImageInfinitely,
    CircleLoader
  },
  data() {
    return {
      positions: [],
      categories: [],
      inputMasks: {
        phone: {
          mask: "+{7}(000)000-00-00",
          lazy: false
        },
        driving_licence_series: {
          mask: "00 00",
          lazy: false
        },
        driving_licence_number: {
          mask: "000000",
          lazy: false
        }
      }
    };
  },
  computed: {
    ...mapState("staff", [
      "uploadData",
      "editObject",
      "validationErrors",
      "serverErrors",
      "errorsInfos",
      "fieldRequires",
      "editMode"
    ])
  },
  async mounted() {
    const { objectId } = this.$route.params;
    this.setUploadData(true);
    await this.startEditing(objectId);
    this.resetValidationErrorsObject();

    const positionsRes = await this.getSource({
      url: "/api/dicts/positions/",
      params: {
        page_size: 500
      }
    });

    this.positions = positionsRes.data.map(item => ({ ...item, value: item.id, text: item.name }));

    const categoriesRes = await this.getSource({
      url: "/api/dicts/driving-licence-categories/",
      params: {
        page_size: 500
      }
    });

    this.categories = categoriesRes.data.map(item => ({ ...item, value: item.id, text: item.name }));

    this.setUploadData(false);
  },
  beforeDestroy() {
    this.setEditMode(false);
  },
  methods: {
    ...mapActions(["getSuggestion", "getSource", "getOwners"]),
    ...mapActions("staff", ["addNewObject", "updateObject", "startEditing"]),
    ...mapMutations("staff", [
      "updateEditObject",
      "updateEditObjectField",
      "updateValidationErrorsObject",
      "updateValidationErrorsField",
      "updateServerErrorsField",
      "resetValidationErrorsObject",
      "setUploadData",
      "setEditMode"
    ]),
    updateData(data) {
      const target = data.fieldname.split(".");

      if (Array.isArray(target) && target.length > 0) {
        if (target[0] === "coordinatesString") {
          this.coordinatesString = data.value;
          return;
        }

        this.updateValidationErrorsField({ fieldName: target[1], newFieldValue: false });
        this.updateServerErrorsField({ fieldName: target[1], newFieldValue: false });

        if (target[1] === "responsible_for_liquidation") {
          this.updateEditObjectField({ fieldName: target[1], newFieldValue: data.data === null ? null : data.data });
          return;
        }

        this.updateEditObjectField({ fieldName: target[1], newFieldValue: data.value === null ? null : data.value });
      }
    },
    newAddImage(data) {
      data.isNew = true;
      this.updateEditObjectField({ fieldName: "attachments", newFieldValue: [data, ...this.editObject.attachments] });
    },
    newDeleteImage(id) {
      this.updateEditObjectField({
        fieldName: "attachments",
        newFieldValue: [...this.editObject.attachments.filter(e => e.id !== id)]
      });
    },
    isDriver() {
      return this.editObject.positions.some(positionId => {
        if (this.positions.find(position => position.id === positionId && position.name === "Водитель")) {
          return true;
        }
        return false;
      });
    }
  }
};
</script>
